import * as React from "react";
import type { SVGProps } from "react";
const SvgIcSettings = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#040747"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m20.807 7.624-.623-1.08a1.913 1.913 0 0 0-2.608-.705 1.904 1.904 0 0 1-2.61-.678 1.83 1.83 0 0 1-.255-.915 1.913 1.913 0 0 0-1.914-1.968h-1.254A1.904 1.904 0 0 0 9.64 4.191a1.913 1.913 0 0 1-1.913 1.886 1.83 1.83 0 0 1-.916-.257 1.913 1.913 0 0 0-2.608.705l-.669 1.099a1.913 1.913 0 0 0 .696 2.608 1.913 1.913 0 0 1 0 3.314 1.904 1.904 0 0 0-.696 2.6l.632 1.089a1.913 1.913 0 0 0 2.609.741 1.894 1.894 0 0 1 2.6.696c.164.277.252.593.255.915 0 1.056.857 1.913 1.913 1.913h1.255c1.053 0 1.908-.85 1.912-1.904a1.904 1.904 0 0 1 1.914-1.913c.321.009.636.097.915.256a1.913 1.913 0 0 0 2.609-.695l.659-1.099a1.904 1.904 0 0 0-.696-2.608 1.904 1.904 0 0 1-.696-2.61c.166-.289.406-.529.696-.695a1.913 1.913 0 0 0 .696-2.6z"
      clipRule="evenodd"
    />
    <path
      stroke="#040747"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12.175 14.525a2.636 2.636 0 1 0 0-5.272 2.636 2.636 0 0 0 0 5.272"
    />
  </svg>
);
export default SvgIcSettings;
